import * as exportBatchesActions from '../actions/export-batches.actions';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { ExportBatchApiModel } from 'app/models/export-batch-api.model';

export interface State {
  exportBatches: ExportBatchApiModel[];
  isLoading: boolean;
  isReady: boolean;
  totalExportBatches: number;
  isSaving: boolean;
}

export const initialState: State = {
  exportBatches: [],
  isLoading: false,
  isReady: false,
  totalExportBatches: 0,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(exportBatchesActions.createExportBatch, (state) => {
    return {
      ...state,
      isSaving: true,
    };
  }),
  on(
    exportBatchesActions.createExportBatchSuccess,
    exportBatchesActions.createExportBatchFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    exportBatchesActions.resetExportBatches,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
